//import _ from "lodash";
import React, { useState, useEffect } from "react";
import { withRouter, Redirect } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import config from "../../config";
import store, { persistor } from "../../store";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import { trackPage } from "../../analytics";

import { SignupCard, StepHeader } from "../../signupComponents";

import SearchResult from "./searchResult";
import filterArea from "./filterArea";
import styles from "../form/styles";

const withSignupEventCode = (path, signupEventCode) =>
  signupEventCode
    ? `${path}?signupEventCode=${encodeURIComponent(signupEventCode)}`
    : path;

const Inside = props => {
  const [filteredArea, setFilteredArea] = useState([
    { v: 0, l: "", a: "", c: "" }
  ]);
  const [selectedArea, setSelectedArea] = useState(null);

  const { classes } = props;

  useEffect(() => {
    trackPage("inside");
  }, []);

  // If someone hits /inside directly without a signupclass, send them home
  const ss = store.getState();
  if (!ss.data || ss.data.signupclass === "") {
    return (
      <Redirect
        to={withSignupEventCode(
          config.SIGNUP.APP_PATH + "/",
          props.signupEventCode
        )}
      />
    );
  }

  const handleInputChange = event => {
    const value = event.target.value || "";
    if (!value.length) {
      setFilteredArea([{ v: 0, l: "", a: "", c: "" }]);
    } else {
      setFilteredArea(filterArea(value, 20));
    }
  };

  const handleSelectArea = value => {
    setSelectedArea(value);
  };

  const handleConfirmYes = () => {
    props.setAreaid(selectedArea.v);
    props.setAreaName(selectedArea.a);
    if (props.setSignupclass) {
      props.setSignupclass("inside");
    }
    props.history.push(
      withSignupEventCode(
        config.SIGNUP.APP_PATH + "/autolocation",
        props.signupEventCode
      )
    );
  };

  const handleConfirmNo = () => {
    props.setAreaid(null);
    props.setAreaName("");
    if (props.setSignupclass) {
      props.setSignupclass("outside");
    }
    props.history.push(
      withSignupEventCode(
        config.SIGNUP.APP_PATH + "/outside",
        props.signupEventCode
      )
    );
  };

  const onBackFromStepHeader = () => {
    // same pattern as Form.goBack but simpler:
    // clear signup persistent state and return to step 1 (Home)
    persistor.pause();
    persistor.flush().then(() =>
      persistor.purge().then(() => {
        sessionStorage.removeItem("signupformPersistentState");
        props.history.push(
          withSignupEventCode(
            config.SIGNUP.APP_PATH + "/",
            props.signupEventCode
          )
        );
      })
    );
  };

  return (
    <Grid container justify="center">
      <Grid item xs={12}>
        {/* hard cap + centering wrapper (same as Form) */}
        <div style={{ width: "100%", maxWidth: 860, margin: "0 auto" }}>
          <SignupCard size="xl" maxw={860}>
            <StepHeader
              step={2}
              eyebrow={
                selectedArea == null ? "Where do you want service?" : undefined
              }
              title={
                selectedArea == null
                  ? "Enter the name of your town, village, hamlet, lake, or subdivision."
                  : undefined
              }
              onBack={onBackFromStepHeader}
            />

            <div className={classes.mobilePadding}>
              {selectedArea == null ? (
                <>
                  {/* Search input (styled via styles.searchField) */}
                  <TextField
                    id="location-search"
                    label="Search for your location..."
                    variant="outlined"
                    fullWidth
                    onChange={handleInputChange}
                    autoComplete="off"
                    className={classes.searchField}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      )
                    }}
                  />

                  {/* Results list */}
                  <SearchResult
                    selectArea={handleSelectArea}
                    filteredResults={filteredArea}
                  />
                </>
              ) : (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <h3>
                      Do you confirm you live within the community of{" "}
                      <b>{selectedArea.a}</b>?
                      <br />
                      (If you live outside the community, click "No")
                    </h3>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <button
                      type="button"
                      onClick={handleConfirmYes}
                      style={{
                        width: "100%",
                        height: 44,
                        borderRadius: 10,
                        border: "none",
                        cursor: "pointer",
                        color: "#fff",
                        backgroundColor: "#f44758",
                        fontWeight: 700
                      }}
                    >
                      Yes
                    </button>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <button
                      type="button"
                      onClick={handleConfirmNo}
                      style={{
                        width: "100%",
                        height: 44,
                        borderRadius: 10,
                        border: "1px solid #f44758",
                        cursor: "pointer",
                        color: "#f44758",
                        backgroundColor: "#fff",
                        fontWeight: 700
                      }}
                    >
                      No
                    </button>
                  </Grid>
                </Grid>
              )}
            </div>
          </SignupCard>
        </div>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(withRouter(Inside));
